/* Theme-owned accessibility repairs for widgets that generate markup at runtime. */
(function () {
  const focusableSelector = 'a[href], area[href], button, input, select, textarea, [tabindex]';
  const savedTabindex = 'data-theme-original-tabindex';

  function makeHiddenSlickControlsUntabbable(root) {
    const hiddenSelector = '.slick-slide[aria-hidden="true"], .slick-dots li[aria-hidden="true"]';
    const visibleSelector = '.slick-slide[aria-hidden="false"], .slick-dots li[aria-hidden="false"]';

    root.querySelectorAll(hiddenSelector).forEach((container) => {
      container.setAttribute('inert', '');
      container.querySelectorAll(focusableSelector).forEach((element) => {
        if (!element.hasAttribute(savedTabindex)) {
          element.setAttribute(savedTabindex, element.getAttribute('tabindex') || '');
        }
        element.setAttribute('tabindex', '-1');
      });
    });

    root.querySelectorAll(visibleSelector).forEach((container) => {
      container.removeAttribute('inert');
      container.querySelectorAll(`[${savedTabindex}]`).forEach((element) => {
        const originalTabindex = element.getAttribute(savedTabindex);
        if (originalTabindex) element.setAttribute('tabindex', originalTabindex);
        else element.removeAttribute('tabindex');
        element.removeAttribute(savedTabindex);
      });
    });
  }

  function syncSlickAccessibility() {
    makeHiddenSlickControlsUntabbable(document);
    document.querySelectorAll('.slick-track[role="listbox"]').forEach((track) => {
      if (!track.hasAttribute('aria-label')) track.setAttribute('aria-label', 'Product media');
    });
  }

  function hideEmptyProductDescriptionLinks() {
    const descriptionSelectors = [
      '.template-product .product-content .tab-pane',
      '.template-product .nav-tab-info-vertical .card-body',
      '.template-product .product-single__shortdes',
    ];

    document.querySelectorAll(`${descriptionSelectors.join(', ')} a[href]`).forEach((link) => {
      const hasAccessibleContent = link.textContent.trim() || link.querySelector('img[alt], svg[aria-label]');
      if (!hasAccessibleContent) link.hidden = true;
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    syncSlickAccessibility();
    hideEmptyProductDescriptionLinks();
    new MutationObserver(syncSlickAccessibility).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'class'],
    });
  });
}());
